interface IGetRemainingQuantityAfterSelectionArgs {
  /** Quantity still available, not counting what this item already holds in the cart. */
  availableQuantityExcludingCart: number;
  /** Quantity the cart already holds for this item. */
  quantityInCart: number;
  /** Quantity the dish modal's picker reads. It reaches the cart only when the user submits. */
  uncommittedQuantity: number;
}

/**
 * Quantity of a dish that would be left if the dish modal's current selection were committed.
 *
 * The dish card's stepper writes straight to the cart, so its availability chip moves with every
 * tap. The modal holds its selection until submit, so the same chip would sit on pre-modal numbers
 * and never reach "Max Quantity" however far the user stepped up. Projecting the uncommitted
 * quantity onto stock gives the card's behaviour without the modal having to write early.
 */
export const getRemainingQuantityAfterSelection = ({
  availableQuantityExcludingCart,
  quantityInCart,
  uncommittedQuantity,
}: IGetRemainingQuantityAfterSelectionArgs): number =>
  availableQuantityExcludingCart + quantityInCart - uncommittedQuantity;
